<div [formGroup]="addressForm">
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'components.address-form.country' | translate }}</mat-label>
        <mat-select formControlName="country"
                    [compareWith]="countryEquals">
          <mat-option>
            <ngx-mat-select-search [formControl]="countriesFilterControl"
                                   [clearSearchInput]="false"
                                   placeholderLabel="{{ 'global.labels.country-select.placeholder' | translate }}"
                                   noEntriesFoundLabel="{{ 'global.labels.country-select.no-entries' | translate }}">
              <mat-icon ngxMatSelectSearchClear
                        color="primary">
                delete
              </mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let country of availableCountries"
                      [value]="country">
            {{ country.name }}
          </mat-option>
        </mat-select>
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'components.address-form.county' | translate }}</mat-label>
        <mat-select formControlName="county"
                    [compareWith]="countyEquals">
          <mat-option>
            <ngx-mat-select-search [formControl]="countiesFilterControl"
                                   [clearSearchInput]="false"
                                   placeholderLabel="{{ 'global.labels.county-select.placeholder' | translate }}"
                                   noEntriesFoundLabel="{{ 'global.labels.county-select.no-entries' | translate }}">
              <mat-icon ngxMatSelectSearchClear
                        color="primary">
                delete
              </mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let county of filteredCounties"
                      [value]="county">
            {{ county.name }}
          </mat-option>
        </mat-select>
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'components.address-form.locality' | translate }}</mat-label>
        <mat-select formControlName="locality"
                    [compareWith]="localityEquals">
          <mat-option>
            <ngx-mat-select-search [formControl]="localitiesFilterControl"
                                   [clearSearchInput]="false"
                                   placeholderLabel="{{ 'global.labels.locality-select.placeholder' | translate }}"
                                   noEntriesFoundLabel="{{ 'global.labels.locality-select.no-entries' | translate }}">
              <mat-icon ngxMatSelectSearchClear
                        color="primary">
                delete
              </mat-icon>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let locality of availableLocalities"
                      [value]="locality">
            {{ locality.name }}
          </mat-option>
        </mat-select>
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.postal-code' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.postal-code' | translate }}"
               formControlName="postalCode"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field>
        <mat-label>{{ 'components.address-form.street' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.street' | translate }}"
               formControlName="street"
               autocomplete="off"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete"
                          [displayWith]="streetName"
                          (optionSelected)="onStreetSelected($event)">
          <mat-option *ngFor="let street of availableStreets"
                      [value]="street">
            {{ street.name }}, {{ street.type }}
          </mat-option>
        </mat-autocomplete>
        <span matSuffix class="street-type">{{ addressForm.controls.street.value?.type }}</span>
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.street-number' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.street-number' | translate }}"
               formControlName="streetNumber"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-2">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.building' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.building' | translate }}"
               formControlName="building"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-2">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.building-entry' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.building-entry' | translate }}"
               formControlName="buildingEntry"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-2">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.building-floor' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.building-floor' | translate }}"
               formControlName="buildingFloor"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-2">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.building-apartment' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.building-apartment' | translate }}"
               formControlName="buildingApartment"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
    <div class="col-sm-4">
      <mat-form-field color="primary">
        <mat-label>{{ 'components.address-form.details' | translate }}</mat-label>
        <input matInput
               placeholder="{{ 'components.address-form.details' | translate }}"
               formControlName="address"
               autocomplete="off">
        <mat-error matErrorMessage></mat-error>
      </mat-form-field>
    </div>
  </div>
</div>